import {
  AllowedComponentsProperties,
  Constants,
  ContainerState,
  EditConfig,
  MapTo,
  withComponentMappingContext,
} from '@adobe/aem-react-editable-components';
import { PlaceHolderModel } from '@adobe/aem-core-components-react-base/dist/common/placeholder';
import { CustomAllowedComponentsContainer } from '../Container/CustomAllowedComponentsContainer';

export type LearningAcademyResponsiveGridProperties = {
  gridClassNames: string;
  columnClassNames: { [key: string]: string };
} & AllowedComponentsProperties;

export class LearningAcademyResponsiveGrid extends CustomAllowedComponentsContainer<
  LearningAcademyResponsiveGridProperties,
  ContainerState
> {
  get containerProps(): { [key: string]: string } {
    // @ts-ignore
    const containerProps = super.containerProps;

    containerProps.className = `${containerProps.className || ''} ${this.props.gridClassNames}`;

    return containerProps;
  }

  // @ts-ignore
  get placeholderProps(): PlaceHolderModel {
    // @ts-ignore
    const props = super.placeholderProps;

    props.placeholderClassNames = `${props.placeholderClassNames || ''} ${
      Constants._RESPONSIVE_GRID_PLACEHOLDER_CLASS_NAMES
    }`;

    // @ts-ignore
    return props;
  }

  getItemComponentProps(item: any, itemKey: string, itemPath: string): { [key: string]: string } {
    const attrs = super.getItemComponentProps(item, itemKey, itemPath);

    attrs.className = attrs.className || '';
    attrs.className +=
      this.props.columnClassNames && this.props.columnClassNames[itemKey]
        ? ` ${this.props.columnClassNames[itemKey]}`
        : '';

    return attrs;
  }
}

const config: EditConfig<LearningAcademyResponsiveGridProperties> = {
  isEmpty(props: LearningAcademyResponsiveGridProperties): boolean {
    return props.cqItemsOrder && props.cqItemsOrder.length > 0;
  },
};

MapTo<LearningAcademyResponsiveGridProperties>('wcm/foundation/components/responsivegrid')(
  withComponentMappingContext(LearningAcademyResponsiveGrid),
  config,
);
